const ErrorLayout = ({ element }) => {
  return element;
};

export default ErrorLayout;